import React, { useState } from 'react';
import BACKEND_URL from "./../../config/config.js"
import "../../App.css";
import { useNavigate } from 'react-router-dom';
import EconoJournalLogo from "../../components/EconoJournalLogo";
import { showPopup } from "../../utils/popup";

function App() {
  const [userId, setUserId] = useState('');

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${BACKEND_URL}/responses`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: userId,
        })
      });

      if (!res.ok) {
        const error = await res.text();
        showPopup(error, {
          title: "Error al enviar",
          type: "error",
        });
        return;
      }

      navigate("/gracias");
    } catch (error) {
      showPopup(error.message, {
        title: "Error de red o de servidor",
        type: "error",
      });
    }
  };


  return (
    <div className='container'>
      <EconoJournalLogo className="logoECJ" />
      <h2>Acreditación: Energy Day</h2>
      <h4>Completá con tu código de registro para confirmar tu participación.</h4>
      <form onSubmit={handleSubmit}>
          <label>Código de registro: <b>*</b></label>
          <input type="text" value={userId} onChange={(e) => setUserId(e.target.value)} required title="Debes completar con tu código de registro" />
          <button type="submit">Confirmar asistencia</button>
      </form>
    </div>
  );
}

export default App;
